module.exports = __webpack_public_path__ + "c3024490bd68ebce6b191ed4e9c02d1b.png";